import { Component, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-reviews-home',
  templateUrl: './reviews-home.component.html',
  styleUrls: ['./reviews-home.component.scss'],
})
export class ReviewsHomeComponent {
  // Component logic goes here
}